import { render, staticRenderFns } from "./VendorHome.vue?vue&type=template&id=6c2f5a21&scoped=true&"
import script from "./VendorHome.vue?vue&type=script&lang=js&"
export * from "./VendorHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2f5a21",
  null
  
)

export default component.exports